import { Container } from "./styled";
import { Column } from "@ant-design/plots";
import { useNavigate } from "react-router-dom";


const TeamChartComponent = ({config, isLoading}) => {
    const navigate = useNavigate();

    const handleChartClick = (e) => {
        if(e.type === "click") {
            if(e.data?.data && e.data.data.id) {
                let id = e.data.data.id;
                let method = e.data.data.method;
                let tabKey = method === "Hazmat" ? 1 : 2;
                navigate(`/precimar_ulm_600_e/${id}`, {state: tabKey});
                localStorage.setItem("sessionId", id);
            }
        }
    }

    return (
        <Container className="team-chart-1">
            <Column {...config} style={{ height: "30vh"}} onEvent={(chart, event) => handleChartClick(event)}/>
        </Container>
    );
};

export default TeamChartComponent;